// Persistent cache for merged log fetches.
const DB_NAME = "pbxscribe-logs-cache";
const DB_VERSION = 1;
const STORE_NAME = "logs_by_key";

let dbPromise = null;

const openLogsDb = () =>
  new Promise((resolve) => {
    if (typeof indexedDB === "undefined") {
      resolve(null);
      return;
    }
    try {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = () => {
        const db = request.result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => resolve(null);
      request.onblocked = () => resolve(null);
    } catch {
      resolve(null);
    }
  });

const getLogsDb = () => {
  if (!dbPromise) {
    dbPromise = openLogsDb();
  }
  return dbPromise;
};

export const readPersistedLogs = async (key) => {
  const db = await getLogsDb();
  if (!db) return null;
  return new Promise((resolve) => {
    try {
      const transaction = db.transaction(STORE_NAME, "readonly");
      const request = transaction.objectStore(STORE_NAME).get(String(key));
      request.onsuccess = () => resolve(request.result || null);
      request.onerror = () => resolve(null);
    } catch {
      resolve(null);
    }
  });
};

export const writePersistedLogs = async (key, value) => {
  const db = await getLogsDb();
  if (!db) return;
  try {
    const transaction = db.transaction(STORE_NAME, "readwrite");
    transaction.objectStore(STORE_NAME).put(value, String(key));
  } catch {
    // Best-effort cache only.
  }
};

export const removePersistedLogs = async (key) => {
  const db = await getLogsDb();
  if (!db) return;
  try {
    const transaction = db.transaction(STORE_NAME, "readwrite");
    transaction.objectStore(STORE_NAME).delete(String(key));
  } catch {
    // Best-effort cache only.
  }
};

export const clearPersistedLogs = async () => {
  const db = await getLogsDb();
  if (!db) return;
  try {
    const transaction = db.transaction(STORE_NAME, "readwrite");
    transaction.objectStore(STORE_NAME).clear();
  } catch {
    // Best-effort cache only.
  }
};
